<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Add RedChirp Phone Number</v-card-title>

    <v-card-text>
    <v-form
        v-if="monitoring_order_id == null"
    >
        <v-text-field
            label="Area Code"
            v-model="search_code"
            @keydown.enter="$event.preventDefault(); onSearch()"
            autofocus
            v-if="!search_toll_free"
            autocomplete="off"
        >
            <v-icon 
                slot="append-outer" 
                v-on:click="onSearch"
                color="primary"
                style="pointer-events: auto;"
                v-if="!searching"

            >
                mdi-magnify
            </v-icon>

            <v-progress-circular
                slot="append-outer" 
                :size="24"
                :width="3"
                color="primary"
                indeterminate
                v-if="searching"
            >
            </v-progress-circular>
        </v-text-field>

        <div
            v-if="!search_toll_free && $rc.isSystemAdmin()"
        >
            To search toll free numbers, <a v-on:click="onClickSearchTollFreeNumbers">click here</a> (not recommended, system admin only)
        </div>

        <div
            v-if="search_toll_free"
        >
            To search local (not toll free) numbers, <a v-on:click="onClickSearchLocalNumbers">click here</a>
        </div>

        <v-radio-group v-model="selected_endpoint" :mandatory="true">
            <v-radio 
                v-for="(number, index) in search_results"
                :key="index"
                :label="prettyPrint(number)" 
                :value="number.endpoint"
            >
            </v-radio>
        </v-radio-group>

        <div
            v-if="search_toll_free"
        >
            <ul>
                <li>All Toll-Free numbers added after 5/15/2022 must go through toll-free number verification.</li>
                <li><b>WARNING:</b>  This proces is slow and painful.  Only buy a toll free number <b>if you absolutely can not help it</b></li>
                <li>Bandwidth Toll-Free Verification Handbook (link to <a href="https://support.bandwidth.com/hc/en-us/articles/1500006962542-Bandwidth-toll-free-verification-handbook-" target="_blank">https://support.bandwidth.com/hc/en-us/articles/1500006962542-Bandwidth-toll-free-verification-handbook-</a>)</li>
                <li>Start Toll-Free Verification Request (link to <a href="https://www.bandwidth.com/forms/toll-free-campaign-brief/">https://www.bandwidth.com/forms/toll-free-campaign-brief/</a>)</li>
            </ul>
        </div>
    </v-form>

    <div
        style="text-align: center; padding-top: 60px; padding-bottom: 60px;"
        v-if="monitoring_order_id != null"
    >
        <v-progress-circular
            indeterminate
            color="red"
        >
        </v-progress-circular>
    </div>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
            :disabled="monitoring_order_id != null"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="getSelectedAvailableNumber() == null || monitoring_order_id != null"
        >
        Add Phone Number
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');
const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {

    data() {
        return {
            dialog: false,

            organization_id: null,
            is_system_admin: false,
            for_employee_id: null,
            as_primary_orgaization_bot: false,


            search_code: null,
            search_results: null,
            searching: false,
            selected_endpoint: null,

            search_toll_free: false,

            monitoring_order_id: null,
        }
    },

    methods: {

        showDialog(organization_id, is_system_admin, for_employee_id, as_primary_orgaization_bot) 
        {
            this.monitoring_order_id = null;

            this.organization_id = organization_id;
            this.is_system_admin = is_system_admin;
            this.for_employee_id = for_employee_id;
            this.as_primary_orgaization_bot = as_primary_orgaization_bot == null ? false : as_primary_orgaization_bot;
            this.search_results = null;
            this.searching = false;
           
            this.selected_endpoint = null;

            this.search_code = '';
            this.search_toll_free = false;

            this.dialog = true;

            if ( this.search_toll_free )
                this.onSearch(); 
        },
        
        onSearch()
        {
            this.searching = true;
            
            this.$rc.rest(
                'LIST: /api/v1/comms/search-available-phone-numbers',
            
                {
                    'full_text' : this.search_code,
                    'organization_id': this.organization_id,
                },
            
                (data) => {
                    this.searching = false;
                    this.search_results = data.available_numbers;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search available phone numbers');
                },
            );

        },
        
        onClickSearchTollFreeNumbers()
        {
            this.search_toll_free = true;
            this.search_code = 'toll-free';
            this.onSearch();
        },

        onClickSearchLocalNumbers()
        {
            this.search_toll_free = false;
            this.search_code = '';
            this.onSearch();
        },

        onOk()
        {
            let number = this.getSelectedAvailableNumber();

            let params = {
                'organization_id' : this.organization_id,
                'number' : number,
                'for_employee_id' : this.for_employee_id,
                'as_primary_orgaization_bot' : this.as_primary_orgaization_bot,
            };


            this.$rc.orderPhoneNumber(
                params,

                (data) => {

                    this.monitoring_order_id = data.order_id;

                    setTimeout(this.checkOrderStatus, 1000);
                },

                () => {
                    this.$rc.alert('Error', 'Unable to purchase the requested phone number.  Please try again');
                },
            );
        },

        checkOrderStatus()
        {
            this.$rc.rest(
                'GET: /api/v1/comms/order-phone-number/:order_id',
            
                {
                    'order_id' : this.monitoring_order_id,
                },
            
                (data) => {

                    if ( data.state == 'complete' )
                    {
                        this.$rc.snackbar('Phone number purchase compelte',2000);
                        this.dialog = false;
                        this.$emit('ok');
                        return;
                    }
                    else if ( data.state == 'failed' )
                    {
                        this.$rc.alert('Unable to purchase phone number','Unable to purchase the phone number');
                        this.dialog = false;
                        return;
                    }
                    else
                    {
                        setTimeout(this.checkOrderStatus, 2000);
                        return;
                    }
                },
            
                () => {
                    this.dialog = false;
                    this.$rc.alert('Unable to purchase phone number','Unable to purchase the phone number');
                },
            );
        },

        getSelectedAvailableNumber()
        {
            if ( this.search_results == null ) return null;
            if ( this.selected_endpoint == null ) return null;

            for ( let i = 0; i < this.search_results.length; i++ )
            {
                if ( this.search_results[i].endpoint == this.selected_endpoint )
                {
                    return this.search_results[i];
                }
            }

            return null;
        },

      

        prettyPrint(number)
        {
            let ret = E164.prettyPrintUsPhoneNumber(number.endpoint);

            if ( number.subtype == 'ptsn-toll-free' )
                ret += ' (toll free)';

            if ( this.is_system_admin || this.$rc.$state.isAuthActorSystemAdmin() )
            {
                let owned = number.owned_by_redchirp ? "already owned by RedChirp" : "available for purchase";
                ret += ' ('+number.network+', '+owned+')';
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>